import React from "react";
import {
  homeObjOne,
  homeObjTwo,
  homeObjThree,
  homeObjFour,
  FAQdata,
} from "./Data";
import { InfoSection, ACard, FAQ, Herosection } from "../../components";
import styles from "./Home.module.css";
import { makeStyles } from "@material-ui/core/styles";
import ScrollToTop from "../../components/ScrollToTop";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "grid",
    // gridTemplateColumns: RepeatWrapping(auto-fill, minmax("250px", "1fr")),
    width: "100%",
    backgroundColor: "bisque",
    margin: "1em",
    justifyContent: "center",
    // '& > *': {
    // margin: theme.spacing(3),

    // },
  },
}));

function Home() {
  const classes = useStyles();

  return (
    <>
      <ScrollToTop />

      <InfoSection {...homeObjThree} />
      <Herosection />
      <InfoSection {...homeObjTwo} />

      <InfoSection {...homeObjFour} />

      <ACard />

      <InfoSection {...homeObjOne} />
      {/* <FAQ data={FAQdata} /> */}
    </>
  );
}

export default Home;
